// extracted by mini-css-extract-plugin
module.exports = {"container":"GitFieldSection_container__3e2oE","content":"GitFieldSection_content__7Z3rR","bg":"GitFieldSection_bg__PjAdA"};